import React, { useState } from 'react'
import { toast } from 'react-toastify'

const timeOut = 1450

// IMPORTANT READ BELOW
// Use token as a empty vessel if copying either and api key or token use the token field to pass the data

const CopyButton = ({ token, expireDate, className = '', children, template = '', customMessage }) => {
  const templates = {
    email: `Hello -\n\nTo access Inspire Health Tech's API documentaion, first go to this URL:\nhttps://docs.aipredict.medipro.inspireht.com/\n\nNext, Copy/Paste the following for UserName: (no Password is required)\n\n${token}\n\nPlease note that this token is set to expire ${expireDate}.\n\nThank you! Please let us know if you have any questions.\n\nThe Inspire Health Tech team`,
    token
  }

  const copyMessage = customMessage || templates[template]
  // Switch logic
  const [copied, setCopied] = useState(false)
  const text = copied ? `Copied ${template}` : children
  const styleTemplate = template.charAt(0).toUpperCase() + template.slice(1)

  const copiedAndAlert = (e) => {
    e.preventDefault()
    navigator.clipboard.writeText(copyMessage)
    toast.info(`${styleTemplate} is copied to clipboard`)
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, timeOut)
  }

  // Subtle, secondary bordered style (matches the "Copy Invitation Email" action
  // on the customer edit page) so copy buttons read as quiet utilities rather
  // than loud primary actions.
  const base = 'inline-flex items-center rounded border px-2.5 py-1 text-xs transition disabled:cursor-default'
  const stateStyle = copied
    ? 'border-green-300 bg-green-50 text-green-700'
    : 'border-gray-300 text-gray-600 hover:bg-gray-50'

  return (
    <button type='button' disabled={copied} onClick={copiedAndAlert} className={`${base} ${stateStyle} ${className}`}>{text}</button>
  )
}

export default CopyButton
